document.addEventListener("DOMContentLoaded", function () {

  const article = document.querySelector(".article-template__content");
  const toc = document.getElementById("tinch-toc");

  if (!article || !toc) return;

  toc.innerHTML = "";

  const headings = article.querySelectorAll("h2");
  const links = [];

  headings.forEach((heading, index) => {

    if (!heading.id) {
      heading.id = "section-" + (index + 1);
    }

    const link = document.createElement("a");
    link.href = "#" + heading.id;
    link.textContent = heading.textContent;

    toc.appendChild(link);
    links.push(link);
  });

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (entry.isIntersecting) {

        links.forEach(link => link.classList.remove("active"));

        const active = toc.querySelector(
          `a[href="#${entry.target.id}"]`
        );

        if (active) active.classList.add("active");
      }

    });

  }, {
    rootMargin: "-30% 0px -60% 0px"
  });

  headings.forEach(h => observer.observe(h));

});
